import React, { Component } from 'react';

class Cartera extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     */
    render() {
        const { CarteraId } = this.props.data;
        let cartera = this.props.data.accountData.GET_CARTERA.find(x => x.CarteraId == CarteraId);

        if (cartera) {
            cartera = cartera.Descripcion;
        } else {
            cartera = "";
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Cartera</label>
                </div>
                <div className="col-xs-12">
                    <label className="label-secondary">{cartera}</label>
                </div>
            </div>
        );
    }
}

export default Cartera;